export default __webpack_public_path__ + "static/media/trophy1.074da10c.png";